import { render } from "./TDPage.vue?vue&type=template&id=3bb040f3"
import script from "./TDPage.vue?vue&type=script&lang=js"
export * from "./TDPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__